import { useBotDispatchContext } from "../contexts/BotContext";
import { useTreeStateContext } from "../contexts/TreeContext";
import { useEffect, useState } from "react";

function useErrorCheckEditor() {

    const dispatch = useBotDispatchContext();
    const [load, setLoad] = useState(false);
    var { blocks, paths, children } = useTreeStateContext();

    const checkSpellingInput = (value) => {

        let open_parenthesis = value.split("(").length - 1
        let close_parenthesis = value.split(")").length - 1
        let open_brackets = value.split("{").length - 1
        let close_brackets = value.split("}").length - 1
        let open_crochets = value.split("[").length - 1
        let close_crochets = value.split("]").length - 1
        let quotes = value.split('"').length - 1
        let msg = ""
        if (open_parenthesis != close_parenthesis) {
            msg += " ( )"
        }
        if (open_brackets != close_brackets) {
            msg += " { }"
        }
        if (open_crochets != close_crochets) {
            msg += " [ ]"
        }
        if (quotes % 2 != 0) {
            msg += " \"\""
        }

        if (msg != '') {
            msg = "Spelling issues with : " + msg;
        }
        return msg
    }

    const checkErrorBlock = (block, data = {}) => {

        var blocks = data.blocks ? data.blocks : blocks;
        var paths = data.paths ? data.paths : paths;

        const isBlockHavingPathIn = paths.filter(path => path.parent_block_id == block.object_id).length;
        const errors = [];

        // Check if block have a path In
        if (isBlockHavingPathIn == false && block.type.name != "scenario") {
            errors.push({ type: 'block is not link' });
        }

        if (block.action_type && block.action_type.name == 'condition') {
            const result = checkSpellingInput(block.data.condition);
            if (result != '') {
                errors.push({ type: 'Wrong Spelling', data: result });
            }
        }

        if (block.type && block.type.name == 'magic') {
            if (!block.data.jump_id) {
                errors.push({ type: 'Block Error' });
            }
        }


        // Check if block var and if somme error are present 'variables'
        if (block.action_type && block.action_type.name == 'set_var') {
            for (let index in block.data.variables) {
                const variable = block.data.variables[index];
                const result = checkSpellingInput(variable.value);
                if (result != '') {
                    errors.push({ type: 'Wrong Spelling', data: result, index: parseInt(index, 10) });
                }
            }

        }

        // Check if block have somet out paths who are not linked
        for (let indexChild in block.children) {
            let child = block.children[indexChild];

            // this condition is for statement block who don't have any child (is for ending bot)
            // This condition is for ignore jump
            if (block.action_type?.name != "categorization" && indexChild == 0 && block.children.length > 1) {
                continue;
            }
            if (block.type.name == "propos" && block.children.length == 1) {
                continue;
            }

            // Check out path
            const isChildHavingAnOutPath = paths.filter(path => path.child_block_id == child.object_id).length;
            if (isChildHavingAnOutPath == 0) {
                errors.push({ type: 'child block is not link', data: child });
            }
            //if (block.sub_blocks.length > 1 && x == 0) continue;
            /*
            else if (block.sub_blocks.length == 1 && block.type == "propos" && block.informations && block.informations.response_type == "quick") continue;
            else if (sub.out_paths.length == 0) {
                return true;
            }*/
        }

        return errors;
    }

    const checkErrors = (_blocks, _paths, _children) => {
        // Override blocks, paths, children if passed as arguments
        blocks = _blocks != undefined ? _blocks : blocks
        paths = _paths != undefined ? _paths : paths
        children = _children != undefined ? _children : children
        const errors = []
        for (var index in blocks) {
            let block = blocks[index];
            const errorFind = checkErrorBlock(block, { blocks, paths, children })
            if (errorFind.length == 0) {
                continue
            }

            errors[block.object_id] = { ...block, errors: errorFind }
        }

        // Dispatch all errors find
        dispatch({ type: 'setErrors', payload: { errors } })
    }

    const checkErrorsForPath = () => setLoad(true);


    useEffect(() => {
        if (load == false) return;
        checkErrors();
        setLoad(false)
    }, [load, paths]);

    return { checkErrorBlock, checkErrors, checkErrorsForPath }

}

export default useErrorCheckEditor